import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CompareExportsModule } from 'src/app/extensions/compare/exports/compare-exports.module';
import { OrderTemplatesExportsModule } from 'src/app/extensions/order-templates/exports/order-templates-exports.module';
import { QuotingExportsModule } from 'src/app/extensions/quoting/exports/quoting-exports.module';
import { RatingExportsModule } from 'src/app/extensions/rating/exports/rating-exports.module';
import { WishlistsExportsModule } from 'src/app/extensions/wishlists/exports/wishlists-exports.module';

import { FeatureToggleDirective } from 'ish-core/directives/feature-toggle.directive';
import { AppFacade } from 'ish-core/facades/app.facade';
import { ProductContextDisplayProperties, ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { Image } from 'ish-core/models/image/image.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ProductHelper } from 'ish-core/models/product/product.helper';
import { ProductAddToBasketComponent } from 'ish-shared/components/product/product-add-to-basket/product-add-to-basket.component';
import { ProductImageComponent } from 'ish-shared/components/product/product-image/product-image.component';
import { ProductItemVariationsComponent } from 'ish-shared/components/product/product-item-variations/product-item-variations.component';
import { ProductLabelComponent } from 'ish-shared/components/product/product-label/product-label.component';
import { ProductNameComponent } from 'ish-shared/components/product/product-name/product-name.component';
import { ProductPriceComponent } from 'ish-shared/components/product/product-price/product-price.component';
import { ProductMarketingLabelComponent } from 'ish-shared/dias/components/product/product-marketing-label/product-marketing-label.component';

@Component({
  selector: 'ish-product-tile',
  templateUrl: './product-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    ProductImageComponent,
    ProductLabelComponent,
    ProductItemVariationsComponent,
    ProductNameComponent,
    ProductPriceComponent,
    ProductAddToBasketComponent,
    RatingExportsModule,
    QuotingExportsModule,
    CompareExportsModule,
    OrderTemplatesExportsModule,
    WishlistsExportsModule,
    FeatureToggleDirective,
    // ProductPromotionComponent,
    ProductMarketingLabelComponent,
  ],
})
export class ProductTileComponent implements OnInit {
  private context = inject(ProductContextFacade);
  private appFacade = inject(AppFacade);

  product$: Observable<ProductView>;
  isMasterProduct = false;

  ngOnInit() {
    this.product$ = this.context.select('product').pipe(
      tap(product => {
        this.isMasterProduct = ProductHelper.isMasterProduct(product);
      })
    );
  }
  openQuickView(productSku: string) {
    this.appFacade.openQuickView(productSku);
  }

  configuration$(key: keyof ProductContextDisplayProperties) {
    return this.context.select('displayProperties', key);
  }

  getImagesViews(product: ProductView): string[] {
    const images: Image[] = product?.images?.filter(image => image.typeID === 'M');
    const imageViews: string[] = [];

    images?.every((image, index) => {
      if (index > 1) {
        return false;
      }

      if (image.primaryImage) {
        imageViews.unshift(image.viewID);
      } else {
        imageViews.push(image.viewID);
      }

      return true;
    });

    if (!imageViews.length) {
      imageViews.push('');
    }
    if (imageViews.length === 1) {
      imageViews.push(imageViews[0]);
    }
    return imageViews;
  }
}
